import { Link, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { LogOut, LayoutDashboard } from "lucide-react";

export default function Header() {
  const { lang, t, toggleLang, owner, logout } = useApp();
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/85 backdrop-blur-xl border-b border-[#E8DFDC]" data-testid="app-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <span className="text-2xl" aria-hidden>🥻</span>
          <div className="leading-tight">
            <div className={`text-[15px] sm:text-[17px] ${lang === "hi" ? "font-hi" : "font-display"} text-[#6B1F3A]`}>
              {t.brand}
            </div>
            <div className="text-[9px] tracking-[0.25em] uppercase text-[#C9A84C] font-semibold hidden sm:block">
              {t.nav.tagline}
            </div>
          </div>
        </Link>

        <div className="flex items-center gap-2 sm:gap-3">
          <button
            onClick={toggleLang}
            className="text-xs tracking-widest uppercase font-semibold border border-[#E8DFDC] px-3 py-2 hover:border-[#C9A84C] hover:text-[#6B1F3A] transition-colors"
            data-testid="lang-toggle"
            aria-label="Toggle language"
          >
            {lang === "en" ? "हिन्दी" : "EN"}
          </button>
          {owner ? (
            <>
              <button
                onClick={() => navigate("/dashboard")}
                className="hidden sm:inline-flex items-center gap-2 text-xs tracking-widest uppercase font-semibold text-[#6B1F3A] px-3 py-2 hover:bg-[#FCFAF8]"
                data-testid="header-dashboard-btn"
              >
                <LayoutDashboard size={14} /> {t.nav.dashboard}
              </button>
              <button
                onClick={() => { logout(); navigate("/"); }}
                className="inline-flex items-center gap-2 text-xs tracking-widest uppercase font-semibold text-[#9B2226] px-3 py-2 hover:bg-[#FCFAF8]"
                data-testid="header-logout-btn"
              >
                <LogOut size={14} /> <span className="hidden sm:inline">{t.nav.logout}</span>
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-xs tracking-widest uppercase font-semibold px-3 py-2 hover:text-[#6B1F3A]" data-testid="header-login-link">
                {t.nav.login}
              </Link>
              <Link to="/signup" className="btn-primary text-[11px] !py-2 !px-4" data-testid="header-signup-link">
                {t.nav.signup}
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
